/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 21/12/2021
 */


import GenogramItem from "@shared/Genogram/GenogramItem";
import GenogramCustomConnectionItem from "@shared/Genogram/GenogramCustomConnectionItem";
import {plainToClass} from "@qwoach/class-transformer-wrapper";
import TagsContainer from "@shared/Tags/TagsContainer";
import TimelineItem from "@shared/Timeline/TimelineItem";
import IFSPartsItem from "@shared/Genogram/IFSPartsItem.js";
import TlswMeasureItem from "@shared/TlswMeasure/TlswMeasureItem";
import QuoteTemplateItem from "@shared/Template/QuoteTemplateItem";
import SessionPlanTemplateItem from "@shared/Template/SessionPlanTemplateItem";

const SESSION_PLAN_DEBUG_PREFIX = "TL_SESSION_PLAN_DEBUG"

function serializeQuoteTemplateDebug(quoteTemplateItem) {
	return quoteTemplateItem ? {
		templateId: quoteTemplateItem.id || null,
		servicesCount: quoteTemplateItem?.quoteItem?.services?.length || 0,
		sessionGroupCount: (quoteTemplateItem?.quoteItem?.getAllServiceItems?.() || []).filter(item => item.serviceType === "SESSION").length,
	} : null
}

let dummyFirebase = {
	auth(){
		return null
	},
	firestore(){
		return null
	}
}

export default class LocalDataManager {//extends QwoachDataManager {

	genogramItem: GenogramItem = null
	genogramCustomConnections: GenogramCustomConnectionItem[] = []
	tagsContainer: TagsContainer = new TagsContainer()
	timelineItem: TimelineItem = null
	tlswMeasureItem: TlswMeasureItem = null
	quoteTemplateItem: QuoteTemplateItem = null
	sessionPlanTemplateItemsById = new Map()
	todoItemsById = new Map()


	constructor() {
		// super(dummyFirebase);
	}

	generateId() {
		return `local_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`
	}

	generateUid() {
		return this.generateId()
	}

	async getGenogramByClientId(clientId){
		if(!this.genogramItem){
			let genogramItemPlain = {"jsonData":{"boxSelectionEnabled":true,"elements":{"nodes":[{"data":{"id":"1640029491056","type":"male","name":"Alex","resize":true,"bg":"#1890FF","width":76,"height":76,"tags":[],"label":"Alex,\nHusband, 40","_name":"Alex","relationship":"Husband","dateOfBirth":363995999999},"position":{"x":122.5,"y":87.5},"group":"nodes","removed":false,"selected":false,"selectable":true,"locked":false,"grabbable":true,"pannable":false,"classes":"eh-preview-active"},{"data":{"id":"1640029493162","type":"female","name":"Mary","isPrimaryPerson":true,"resize":true,"bg":"#FFC069","width":76,"height":76,"tags":[],"label":"Mary,\n39","relationship":"","dateOfBirth":391989599999},"position":{"x":402.5,"y":87.5},"group":"nodes","removed":false,"selected":false,"selectable":true,"locked":false,"grabbable":true,"pannable":false,"classes":"eh-preview-active"},{"data":{"id":"1645258845305","type":"female","name":"Alice","resize":true,"bg":"#FFC069","width":76,"height":76,"tags":[{"id":"67QSTBdJBMRlW2CHNrcY","createdAt":1645259092032,"schemaVersion":1,"isDeleted":false,"ownerIds":[],"_isSchemaMigrated":false,"_schemaMigratedFrom":-1,"_schemaMigratedTo":-1,"title":"Example Health Condition","color":"#8E24AA","description":"","usageCounter":1}],"label":"Alice,\nDaughter, 20","relationship":"Daughter","dateOfBirth":992555999999},"position":{"x":192.5,"y":332.5},"group":"nodes","removed":false,"selected":false,"selectable":true,"locked":false,"grabbable":true,"pannable":false,"classes":"eh-preview-active"},{"data":{"isAuxNode":true,"parentEdgeId":"1640029494650","childNodeId":"1645258845305","xPositionPercent":0.5053571428571428,"type":"round-rectangle","name":"","resize":true,"width":10,"height":10,"id":"aux_1645258846828","skipSnapToGridY":true,"tags":[]},"position":{"x":192.5,"y":225.5},"group":"nodes","removed":false,"selected":false,"selectable":true,"locked":false,"grabbable":true,"pannable":false,"classes":""}],"edges":[{"data":{"source":"1640029491056","target":"1640029493162","id":"1645258866330","lineType":"bezier","title":"Very Close","lineSubType":"harmony3"},"position":{"x":17.5,"y":17.5},"group":"edges","removed":false,"selected":false,"selectable":true,"locked":false,"grabbable":true,"pannable":true,"classes":""},{"data":{"source":"1640029491056","target":"1640029493162","id":"1640029494650","lineType":"segments","title":"Marriage","lineSubType":"family-marriage","auxNodes":["aux_1645258846828"]},"position":{"x":17.5,"y":17.5},"group":"edges","removed":false,"selected":false,"selectable":true,"locked":false,"grabbable":true,"pannable":true,"classes":"eh-preview-active"},{"data":{"source":"1645258845305","target":"aux_1645258846828","id":"1645258846828","lineType":"bezier","title":"Straight Line","lineSubType":"straight"},"position":{"x":17.5,"y":17.5},"group":"edges","removed":false,"selected":false,"selectable":true,"locked":false,"grabbable":true,"pannable":true,"classes":""}]},"pan":{"x":0,"y":0},"panningEnabled":true,"userPanningEnabled":true,"userZoomingEnabled":true,"zoom":1,"zoomingEnabled":true},"clientId":"pULtZcAzJGeImaInEPfR"}
			this.genogramItem = plainToClass(GenogramItem, genogramItemPlain)
			this.genogramItem.setClientId(clientId)
		}
		return this.genogramItem
	}

	async setGenogramItem(genogramItem){
		this.genogramItem = genogramItem
		console.log("LocalDataManager.setGenogramItem: genogramItem = ", genogramItem)
		console.log("LocalDataManager.setGenogramItem: genogramItem JSON = ", JSON.stringify(genogramItem))
		return this.genogramItem
	}

	async getGenogramCustomConnections() {
		return this.genogramCustomConnections || []
	}

	async setGenogramCustomConnectionItem(genogramCustomConnectionItem){
		let nextItem = plainToClass(GenogramCustomConnectionItem, JSON.parse(JSON.stringify(genogramCustomConnectionItem || {})))
		nextItem.normalize()
		let currentItems = this.genogramCustomConnections || []
		let existingIndex = currentItems.findIndex(item => item.id === nextItem.id)
		if(existingIndex >= 0){
			currentItems.splice(existingIndex, 1, nextItem)
		} else {
			currentItems.push(nextItem)
		}
		this.genogramCustomConnections = currentItems
		return nextItem
	}

	async deleteGenogramCustomConnectionItem(genogramCustomConnectionItem){
		let itemId = typeof genogramCustomConnectionItem === "string" ? genogramCustomConnectionItem : genogramCustomConnectionItem?.id
		this.genogramCustomConnections = (this.genogramCustomConnections || []).filter(item => item.id !== itemId)
	}

	async setGenogramCustomConnections(items = []){
		this.genogramCustomConnections = items.map(item => {
			let nextItem = plainToClass(GenogramCustomConnectionItem, JSON.parse(JSON.stringify(item || {})))
			nextItem.normalize()
			return nextItem
		})
		return this.genogramCustomConnections
	}


	async getIFSPartsItemByClientId(clientId) {
		if(!this.ifsPartsItem){
			// let genogramItemPlain = {"jsonData":{"boxSelectionEnabled":false,"elements":{"nodes":[{"data":{"id":"1712231247759", "nonDeletable": true, "type":"ellipse","name":"Core Self","label":"Core Self","resize":true,"bg":"#FFC069","width":176,"height":176},"position":{"x":332.5,"y":332.5},"group":"nodes","removed":false,"selected":false,"selectable":true,"locked":false,"grabbable":true,"pannable":false,"classes":""}]},"pan":{"x":93,"y":-96},"panningEnabled":true,"userPanningEnabled":true,"userZoomingEnabled":true,"zoom":1,"zoomingEnabled":true}}
			// this.ifsPartsItem = plainToClass(IFSPartsItem, genogramItemPlain)
			this.ifsPartsItem = new IFSPartsItem()
			this.ifsPartsItem.setDefault()
			this.ifsPartsItem.clientId = clientId
		}
		return this.ifsPartsItem
	}

	async setIFSPartsItem(genogramItem){
		this.ifsPartsItem = genogramItem
		return this.ifsPartsItem
	}

	async getTlswMeasureByClientId(clientId) {
		if(!this.tlswMeasureItem){
			this.tlswMeasureItem = new TlswMeasureItem(clientId)
		}
		return this.tlswMeasureItem
	}

	async setTlswMeasureItem(tlswMeasureItem){
		this.tlswMeasureItem = tlswMeasureItem
		return this.tlswMeasureItem
	}



	async getTagsContainerItem(){
		return this.tagsContainer
	}

	async setTagsContainer(tagsContainer){
		this.tagsContainer = tagsContainer
	}

	async getTimelineItemByClientId(clientId){
		if(!this.timelineItem){
			this.timelineItem = new TimelineItem(clientId)
		}
		return this.timelineItem
	}
	async setTimelineItem(timelineItem){
		this.timelineItem = timelineItem
		return this.timelineItem
	}

	async setClientProfile(clientProfile){
		return clientProfile
	}

	async createClientProfile(clientProfile){
		return clientProfile
	}

	async updateClientProfile(clientProfile){
		return clientProfile
	}

	async getQuoteTemplateDefault(userProfile = null) {
		if(!this.quoteTemplateItem){
			this.quoteTemplateItem = QuoteTemplateItem.createDefault(userProfile)
			this.quoteTemplateItem.regenerateId()
		}
		console.log(SESSION_PLAN_DEBUG_PREFIX, "LocalDataManager.getQuoteTemplateDefault", JSON.stringify(serializeQuoteTemplateDebug(this.quoteTemplateItem)))
		return this.quoteTemplateItem
	}

	async setQuoteTemplate(quoteTemplateItem){
		this.quoteTemplateItem = quoteTemplateItem
		console.log(SESSION_PLAN_DEBUG_PREFIX, "LocalDataManager.setQuoteTemplate", JSON.stringify(serializeQuoteTemplateDebug(this.quoteTemplateItem)))
		return this.quoteTemplateItem
	}

	async getSessionPlanTemplate(sessionPlanTemplateId){
		return this.sessionPlanTemplateItemsById.get(sessionPlanTemplateId) || null
	}

	async getSessionPlanTemplateDefault(entryType){
		return await this.getSessionPlanTemplate(entryType) || SessionPlanTemplateItem.createDefault(entryType)
	}

	async setSessionPlanTemplate(sessionPlanTemplateItem){
		this.sessionPlanTemplateItemsById.set(sessionPlanTemplateItem.id, sessionPlanTemplateItem)
		return sessionPlanTemplateItem
	}

	async getTodoItem(todoId){
		return this.todoItemsById.get(todoId) || null
	}

	async batchSetTodoItems(todoItems = []){
		for(let todoItem of todoItems){
			if(todoItem?.id){
				this.todoItemsById.set(todoItem.id, todoItem)
			}
		}
		return todoItems
	}

	async getTodoItemsByDueDateTypeListPager(){
		return {
			hasMore: false,
			async next() {
				return []
			},
		}
	}

	async getSessionEntryListPager() {
		return {
			hasMore: false,
			async next() {
				return []
			},
		}
	}

	async logError() {
		return []
	}

}
